import { map, reject, last } from 'lodash/fp';

const DEFAULT_UID_KEY = 'id';

/**
 * Filter an array of suggestion by comparing it to another array
 * @param {Array.<Object>} selectedData Data source to compare against suggestions
 * @param {string} [pathToIdProperty=id] Path to the id property of selectedData
 * @param {string} [suggestionUidKey=id] Property of a suggestion item to use as an id
 * @return {Function} Filter function that takes an array of suggestions
 * @example
 * filterSuggestions(selectedSuggestions): (Array.<suggestions>) => Array.<filteredSuggestions>
 * filterSuggestions(selectedSuggestions, 'user.id'): (Array.<suggestions>) => Array.<filteredSuggestions>
 * filterSuggestions(selectedSuggestions, 'user.customId'): (Array.<suggestions>) => Array.<filteredSuggestions>
 * filterSuggestions(selectedSuggestions, 'user.customId', 'id'): (Array.<suggestions>) => Array.<filteredSuggestions>
 */
function filterSuggestions(
  selectedData,
  pathToIdProperty = DEFAULT_UID_KEY,
  suggestionUidKey,
) {
  const uidKey = suggestionUidKey || last(pathToIdProperty.split('.'));
  return suggestions => {
    const selectedIds = map(pathToIdProperty, selectedData);
    return reject(
      suggestion => selectedIds.includes(suggestion[uidKey]),
      suggestions,
    );
  };
}

export default filterSuggestions;
